import styled from 'styled-components';

export const TableContainer = styled.div`
  width: 100%;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 0.8rem;
  direction: ltr;
  // table-layout: fixed;

  thead {
    background-color: transparent;
    width: 100%;

    tr {
      width: 100%;
      background-color: transparent;
      width: 100%;
      display: flex;
      align-items: center;
      gap: 1rem;
      // padding: 0.8rem;
      flex: 1;
      flex-grow: 1;

      th {
        font-weight: 600;
        // padding: 0 0 0 1rem !important;
      }
    }
  }

  th,
  td {
    // padding: 0.5rem 0 0.5rem 2rem;
    text-align: left;
    background-color: #ffffff;
    width: 100%;
  }

  th {
    background-color: transparent;
    border: none;
  }

  tbody {
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 0.5rem;
    flex: 1;
    flex-grow: 1;

    tr {
      background-color: #ffffff;
      width: 100%;
      display: flex;
      align-items: center;
      gap: 1rem;
      padding: 0.8rem;
      flex: 1;
      flex-grow: 1;

      // box-shadow: 0 0 0 1px #e1dfec;
      border-radius: 10px;

      td:first-child {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      td:last-child {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }
    }
  }

  th:last-child,
  td:last-child {
    max-width: 80px;
    width: 80px;
    text-align: center;
  }
`;

export const DeleteButton = styled.button`
  min-width: 30px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fdf0ef;
  line-height: 0;
  border-radius: 50%;
  border: none;
  cursor: pointer;
`;

export const RadioButtonWrapper = styled.div<{ isChecked: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  border: 2px solid ${({ isChecked }) => (isChecked ? 'var(--primary-green)' : '#e1dfec')};
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  background-color: transparent;

  input {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;
  }

  .icon {
    display: ${({ isChecked }) => (isChecked ? 'block' : 'none')};
    position: absolute;
    color: var(--primary-green);
  }
`;
